import { useAppConfigContext } from '@ltvco/refresh-lib/ctx';
import { useScreenSize } from '@ltvco/refresh-lib/utils';
import { useNavigate } from 'react-router-dom';

import { constants } from 'appConstants';

import {
  BannerContainer,
  HeaderSection,
  StyledBannerImage,
  StyledBannerContent,
  StyledTextContainer,
  StyledHeaderText,
  StyledBodyText,
  StyledButton,
  BackgroundShapesContainer,
  StyledBackgroundImage,
} from './styledComponents';

export const PersonalityTraitsBanner = () => {
  const imgRewardsBanner = constants?.images?.imgRewardsBanner;
  const imgRewardsBannerBg = constants?.images?.imgRewardsBannerBg;

  const { isMobile, isTablet, isDesktop } = useScreenSize();
  const { trackEventGA4 } = useAppConfigContext();
  const redirect = useNavigate();

  const handleBannerClick = () => {
    trackEventGA4({
      event_name: 'navigation_click',
      type: 'Personality Traits',
      interacted_from: 'rewards',
    });
    redirect('/dashboard/personality-traits');
  };

  const desktopImage = (
    <StyledBackgroundImage
      src={imgRewardsBannerBg}
      sx={{
        height: '100%',
      }}
    />
  );

  const tabletImage = (
    <StyledBackgroundImage
      src={imgRewardsBannerBg}
      sx={{
        height: '200px',
      }}
    />
  );

  const mobileImage = (
    <StyledBackgroundImage
      src={imgRewardsBannerBg}
      height="auto"
      sx={{
        width: '100%',
      }}
    />
  );

  return (
    <BannerContainer>
      <BackgroundShapesContainer data-testid="background-shapes-container">
        {isDesktop && desktopImage}
        {isTablet && !isMobile && tabletImage}
        {isMobile && mobileImage}
      </BackgroundShapesContainer>
      <StyledBannerContent>
        <StyledBannerImage src={imgRewardsBanner} alt="rewards-banner" />

        <StyledTextContainer>
          <HeaderSection>
            <StyledHeaderText variant="h2">
              Get Insight Into Your Personality and Strengths
            </StyledHeaderText>
          </HeaderSection>

          <StyledBodyText variant="body1">
            Discover what drives you. This quick assessment reveals key
            personality traits and strengths—no right or wrong answers, just
            insight into what makes you unique.
          </StyledBodyText>

          <StyledButton variant="contained" onClick={handleBannerClick}>
            Discover Yours
          </StyledButton>
        </StyledTextContainer>
      </StyledBannerContent>
    </BannerContainer>
  );
};

export default PersonalityTraitsBanner;
